import axios from "axios";
import { apiEndpoint } from "../DummyData/DUMMYDATA";

export const createApplication = async (formData) => {
  try {
    let resumeId = null;

    let cvId = null;

    let photoId = null;

    if (formData.coverLetterFile && formData.coverLetterFile.id) {
      cvId = formData.coverLetterFile.id;
    }

    if (formData.cvFile && formData.cvFile.id) {
      resumeId = formData.cvFile.id;
    }

    if (formData.photoFile && formData.photoFile.id) {
      photoId = formData.photoFile.id;
    }

    const languageLevelToId = {
      Basic: 1,
      Intermediate: 2,
      Fluent: 3,
      Native: 4,
    };

    const getComputerSkillsSelect = () => {
      if (
        !formData.computerPrograms ||
        typeof formData.computerPrograms !== "object"
      ) {
        return "";
      }

      const selectedSkills = Object.keys(formData.computerPrograms)
        .filter((key) => formData.computerPrograms[key] === true)
        .sort()
        .join(",");

      return selectedSkills;
    };

    const backendLanguage = formData.language === "al" ? "sq" : formData.language || "en";


    const applicationData = {
      data: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        fullName: formData.firstName + " " + formData.lastName,
        mobilePhone: formData.telefon,
        birthDate: formData.datePersonal,
            language: backendLanguage,
        nationality: formData.nationality,
        gender: parseInt(formData.gjinia),
        address: formData.adresaPersonal,
        startDateAvailable: formData.startDateAvailable,
        salaryRangeExpectationMinimum: formData.salaryRangeExpectationMinimum,
        salaryRangeExpectationMaximum: formData.salaryRangeExpectationMaximum,
        educationHighestLevel: formData.educationHighestLevel,
        educationInstitutionName: formData.educationInstitutionName,
        educationFieldOfStudy: formData.educationFieldOfStudy,
        educationGraduationYearEnd: parseInt(
          formData.educationGraduationYearEnd
        ),
        educationAdditionalCertifications:
          formData.educationAdditionalCertifications,
        jobPosition: {
          id: parseInt(formData.pozicioni),
        },
        availabilityToWork: parseInt(formData.mundësiaPunë) || 1,
        emailAddress: {
          address: formData.email,
        },
        computerSkillsSelect: getComputerSkillsSelect(),
        foreignLanguagesList: formData.foreignLanguages.map((lang) => ({
          language: lang.language,
          proficiencyLevel: languageLevelToId[lang.level],
        })),
        employmentHistoryList: formData.workExperience.map((exp) => ({
          employerName: exp.employerName,
          position: exp.position,
          startDate: exp.startDate,
          endDate: exp.endDate,
          responsibilities: exp.responsibilities,
          employmentReasonForLeaving: exp.employmentReasonForLeaving,
        })),
        hiringStage: {
          id: 1,
        },
        securityBackgroundChecks:
          parseInt(formData.securityBackgroundChecks) || null,
        physicalFitRequirement:
          parseInt(formData.physicalFitRequirement) || null,
        relativesWorking: parseInt(formData.relativesWorking) || null,
        relativesWorkingNameSpecifications:
          formData.relativesWorkingNameSpecifications,
        relativesWorkingRelationshipSpecifications:
          formData.relativesWorkingRelationshipSpecifications,
        jobApplicationNotice: parseInt(formData.jobApplicationNotice) || null,
        creationDate: new Date().toISOString().split("T")[0],
        isInternal: false,
        reasonForApplying: formData.reasonForApplying,
        dataProtectionAgreement: formData.dataProtectionAgreement,
        verificationAuthorization: formData.verificationAuthorization,
        signatureDigital: formData.firstName + " " + formData.lastName,
        dateOfDeclaration: new Date().toISOString().split("T")[0],
        airportSystemsExperience: formData.airportSystemsExperience,
        status: 1,
        ...(resumeId && { resume: { id: resumeId } }),
        ...(cvId && { motivationLetter: { id: cvId } }),
        ...(photoId && { picture: { id: photoId } }),
      },
    };

    const response = await axios.post(
      `${apiEndpoint}/create-application`,
      applicationData,
      {
        headers: {},
      }
    );

    console.log("Application created successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating application:", error);

    if (error.response) {
      console.error("Error status:", error.response.status);
      console.error("Error data:", error.response.data);
    }

    throw error;
  }
};

export const createApplicant = async (formData) => {
  try {
    const applicantResponse = await createApplication(formData);
    let emailAddressId = null;

    if (
      applicantResponse.data &&
      Array.isArray(applicantResponse.data) &&
      applicantResponse.data.length > 0
    ) {
      const applicationData = applicantResponse.data[0];
      emailAddressId = applicationData?.emailAddress?.id;
    } else if (applicantResponse.data?.emailAddress?.id) {
      emailAddressId = applicantResponse.data.emailAddress.id;
    }

    if (!emailAddressId) {
      throw new Error(
        "Could not extract email address ID from application response"
      );
    }

    const applicantData = {
      data: {
        fullName: formData.firstName + " " + formData.lastName,
        emailAddress: {
          id: emailAddressId,
        },
        mobilePhone: formData.telefon,
        birthDate: formData.datePersonal,
        gender: formData.gjinia,
        nationality: formData.nationality,
        address: formData.adresaPersonal,
        email: formData.email,
      },
    };

    const response = await axios.post(
      `${apiEndpoint}/create-applicant`,
      applicantData
    );

    return response.data;
  } catch (error) {
    console.error("❌ Error creating applicant:", error);

    if (error.response) {
      console.error("Error status:", error.response.status);
      console.error("Error data:", error.response.data);
    }

    throw error;
  }
};
